import MobileModalFrame from "../common-components/mobile-modal-frame";
import { useTranslation as useInterfaceTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { fetchPricingHistory, restorePricingChange } from "Redux/middlwares/supplierPricing";
import { PBtn } from "./ui";

const LABELS: Record<string, string> = {
  bend_per_ton: "כיפוף ₪ לטון",
  cut_per_ton: "חיתוך ₪ לטון",
  unit_price: "מחיר ליחידה",
  min_unit_price: "מינימום ליחידה",
  vat_percent: "מע״מ %",
  waste_percent: "פחת %",
  quote_validity_days: "תוקף הצעה (ימים)",
  short_shape_as_unit: "צורה קצרה כיחידה",
  short_shape_max_cm: "אורך מקסימלי ליחידה",
  transport_method: "שיטת הובלה",
  transport_price: "מחיר הובלה",
  transport_free_above_tons: "הובלה חינם מעל (טון)",
  transport_minimum: "מינימום להובלה",
};

const COLUMN_LABEL: Record<string, string> = { ribbed: "מצולע", smooth: "עגול", weldable_extra: "תוספת רתיך" };

export const describeChange = (h: any) => {
  const m = /^diameter_prices\.([\d.]+)\.(\w+)$/.exec(h.field);
  const label = m ? `קוטר ${m[1]} ${COLUMN_LABEL[m[2]] || m[2]}` : LABELS[h.field] || h.field;
  return `${label}: ${h.old_value ?? "—"} ← ${h.new_value ?? "—"}`;
};

export default function PriceHistoryModal({ show, onHide }: { show: boolean; onHide: () => void }) {
  const { t: uiT } = useInterfaceTranslation("interface");
  const { t } = useTranslation(["supplierPricing"]);
  const dispatch = useAppDispatch();
  const history = useAppSelector((s) => s.supplierPricing.history);

  useEffect(() => {
    if (show) dispatch(fetchPricingHistory());
  }, [show, dispatch]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="eb-pr eb-pr-modal">
<MobileModalFrame onClose={onHide}>
      <div className="eb-pr-modal-body">
        <h2 className="eb-pr-modal-title">{t("history")}</h2>
        <table className="eb-pr-table">
          <thead>
            <tr>
              <th> {uiT("Date")} </th>
              <th> {uiT("User")} </th>
              <th> {uiT("Changes")} </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {history.filter((h: any) => !["min_unit_price", "short_shape_as_unit", "short_shape_max_cm"].includes(h.field) && !h.field.endsWith(".weldable_extra")).map((h: any) => (
              <tr key={h.id}>
                <td>{new Date(h.created).toLocaleString("he-IL", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</td>
                <td>{h.user_name}</td>
                <td>{describeChange(h)}</td>
                <td>
                  <PBtn kind="secondary" size="sm" onClick={() => dispatch(restorePricingChange(h.id))}>
                    {t("common.restore")}
                  </PBtn>
                </td>
              </tr>
            ))}
            {history.length === 0 && (
              <tr>
                <td colSpan={4} className="eb-pr-muted">
                  —
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="eb-pr-footer">
          <PBtn kind="secondary" onClick={onHide}>
            {t("common.close")}
          </PBtn>
        </div>
      </div>
    </MobileModalFrame>
</Modal>
  );
}
